import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ICar, IEnergyWalletBalanceDTO, IUser } from 'common_library';
import { CoreService } from 'src/app/services/core.service';

import { AuthService } from '../../services/auth/auth.service';
import { CarPage } from '../car/car.page';
import { MainStateService } from 'src/app/services/state/app-main-state.service';
import { EnergyWalletService } from 'src/app/services/entities/energy-wallet.service';

type UserFormType = {
  email: string;
  name?: string;
  surname?: string;
};

type SettingsFormType = {
  disabled?: boolean;
  canUploadPhotos?: boolean;
  canReview?: boolean;
};

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.page.html',
    styleUrls: ['./user-profile.page.scss'],
    standalone: false
})
export class UserProfilePage implements OnInit {
  energyWallet?: IEnergyWalletBalanceDTO;

  constructor(
    public modalCtrl: ModalController,
    public auth: AuthService,
    public CS: CoreService,
    public mainStateService: MainStateService,
    private energyWalletService: EnergyWalletService,
  ) { }

  async ngOnInit() {
    try {
      this.energyWallet = await this.energyWalletService.getMine();
    } catch (error) {
      this.energyWallet = null;
    }
  }

  formatKwh(valueWh?: number): string {
    return `${(Number(valueWh || 0) / 1000).toFixed(2)} kWh`;
  }

  async addVehicle() {
    const addVehicleModal = await this.modalCtrl.create({
      component: CarPage,
      cssClass: 'yf-modal',
    });
    addVehicleModal.present();
  }

  async editVehicle(car: ICar) {
    const editVehicleModal = await this.modalCtrl.create({
      component: CarPage,
      componentProps: { car },
      cssClass: 'yf-modal',
    });
    editVehicleModal.present();
  }

  async closeMe() {
    await this.modalCtrl.dismiss();
  }
}
